import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DetailedDossierStatus } from "../../types/Dossier";

export const getEmptyDossierStatus = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["emptyDossierStatus"],
    queryFn: (): Promise<DetailedDossierStatus> => {
      return fetchWithAuth<DetailedDossierStatus>("getEmptyDossierStatus");
    },
    enabled: isQueryEnabled(options),
  });
};
